import { useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { getUserById, setUser } from "../modules/Reducers/actions/authActions";

export default function useSessionProfile() {
  const dispatch = useDispatch();
  const profileRequestRef = useRef({ inFlight: false, lastUserId: null });

  const fetchUserProfile = useCallback((userId) => {
    if (!userId) return;
    if (profileRequestRef.current.inFlight && profileRequestRef.current.lastUserId === userId) return;
    if (profileRequestRef.current.lastUserId === userId) return;

    profileRequestRef.current = { inFlight: true, lastUserId: userId };
    getUserById(userId)
      .then(({ success, data: profile }) => {
        if (success) {
          dispatch(setUser(profile));
          if (profile?.profilePicture) {
            localStorage.setItem("pdp", profile.profilePicture);
          }
          return;
        }
        profileRequestRef.current = { inFlight: false, lastUserId: null };
      })
      .catch((error) => {
        profileRequestRef.current = { inFlight: false, lastUserId: null };
        console.error("Error fetching user:", error);
      })
      .finally(() => {
        profileRequestRef.current = {
          inFlight: false,
          lastUserId: profileRequestRef.current.lastUserId,
        };
      });
  }, [dispatch]);

  return fetchUserProfile;
}
